import { FC } from 'react';
import { BarChart2 } from 'lucide-react';

interface ScoreDisplayProps {
    value: number | string | undefined;
}

/**
 * Professional data-chip style display for average score
 * Design consistent with other metric chips but tailored for performance metrics
 */
export const ScoreDisplay: FC<ScoreDisplayProps> = ({ value }) => {
    const score = typeof value === 'number'
        ? value
        : typeof value === 'string'
            ? parseFloat(value)
            : null;

    if (score === null || isNaN(score)) {
        return (
            <span className="text-sm text-gray-400 font-medium">N/A</span>
        );
    }

    const roundedScore = Math.round(score);

    return (
        <div className="flex items-center gap-2 group w-fit">
            {/* Icon Container - using a subtle amber/performance theme for Scores */}
            <div className="flex items-center justify-center w-7 h-7 rounded-md bg-white border border-gray-100 group-hover:border-amber-300 group-hover:bg-amber-50 transition-all duration-200 shadow-sm">
                <BarChart2 className="w-3.5 h-3.5 text-gray-400 group-hover:text-amber-500 transition-colors" />
            </div>

            {/* Text Container */}
            <div className="flex flex-col leading-[1.1]">
                <div className="flex items-baseline gap-1">
                    <span className="text-sm font-bold text-gray-900 tabular-nums">
                        {roundedScore}
                    </span>
                    <span className="text-[11px] font-semibold text-gray-500">
                        Impact
                    </span>
                </div>
                <span className="text-[9px] text-gray-400 font-bold uppercase tracking-wider">
                    Performance Score
                </span>
            </div>
        </div>
    );
};
